export default __webpack_public_path__ + "static/media/Buildings.617e5f6e.png";